
let UserUtils = {
  setToken: function (data) {
    localStorage.setItem('cargoYunSsoToken', data.cargoyunSSOToken);
    localStorage.setItem('wx-user', JSON.stringify(data.wxLoginAccountInfo));
    localStorage.setItem('wx-openid', data.wxLoginAccountInfo ? data.wxLoginAccountInfo.wx_openid : '');
    // localStorage.setItem('platcode', data.wxLoginAccountInfo ? data.wxLoginAccountInfo.token : '');
    localStorage.setItem('access-user', JSON.stringify(data.userInfo));
  },

  getToken: function () {
    return localStorage.getItem('cargoYunSsoToken')
  },

  setPlatCode: function (platcode) {
    return localStorage.setItem('platcode', platcode)
  },

  getPlatCode: function () {
    return localStorage.getItem('platcode')
  },

  getWxOpenId: function () {
    return localStorage.getItem('wx-openid')
  },

  getAccessUser: function () {
    let user = localStorage.getItem('access-user')
    if (user) {
      return JSON.parse(user)
    } else {
      window.location.href = '/cgvp/login?callback=' + window.location.href
    }
  },

  removeToken: function () {
    localStorage.removeItem('cargoYunSsoToken');
    localStorage.removeItem('wx-user');
    localStorage.removeItem('wx-openid');
    localStorage.removeItem('platcode');
    localStorage.removeItem('access-user');
  }
}
export {
  UserUtils
}



// WEBPACK FOOTER //
// ./src/assets/js/user.js